import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-950 text-center px-4 gap-4">
      <p className="text-6xl font-bold text-gray-700">404</p>
      <p className="text-gray-300 text-lg font-medium">Page not found</p>
      <Link to="/dashboard" className="btn-primary">Go to Dashboard</Link>
    </div>
  );
}
